

interface MemoizeOptions<TArgs extends any[],TSerializeKey> {
    serialize(...args: TArgs): TSerializeKey
}

export default function memoize<TArgs extends any[], TRet, TSerializeKey=any>(fn: (...args:TArgs)=>TRet, options: MemoizeOptions<TArgs,TSerializeKey> = {
    serialize: fn.length === 1 ? (x: TArgs[0]) => x : (...args: TArgs) => JSON.stringify(args),
}): (...args:TArgs)=>TRet {
    const cache = new Map<TSerializeKey,TRet>();
    return (...args: TArgs) => {
        const key = options.serialize(...args);
        if (cache.has(key)) {
            return cache.get(key);
        }
        const value = fn(...args);
        cache.set(key, value);
        return value;
    }
}
